import {chopByPatterns} from './chopByPatterns.js';
import {getTrackJson} from 'engine/json/getTrackJson.js';
import {sleep} from 'utils/sleep.js';
import {
    setLoadingText
} from 'actions/index.js';
import {bounceGroupPatterns} from 'engine/BouncingEngine.js';

const getPatternLengths = (sequencerEngine) => {
    let numPatterns = sequencerEngine.tracks[0].patterns.length;
    let patternLengths = [];
    for (let i=0; i < numPatterns; i++) {
        sequencerEngine.switchToPattern(i);
        patternLengths.push(sequencerEngine.length);
    }
    return patternLengths;
};

export const freezeGroupByPatterns = async (group) => {
    let {sequencerEngine} = group;
    sequencerEngine.store.dispatch(setLoadingText("Freezing track\'s patterns"));
    await sleep(100);
    group.sequencerEngine.stop();

    let numPatterns = group.tracks[0].patterns.length;
    let patternLengths = getPatternLengths(sequencerEngine);
    sequencerEngine.switchToPattern(0);

    let audioBuffer = await bounceGroupPatterns(group.sequencerEngine, group);
    let bounces = await chopByPatterns(group.sequencerEngine, audioBuffer, numPatterns, group.tracks);

    // get preset for group
    let {frozenGroup, frozenTracks} = getGroupData(group);
    // delete all the tracks
    sequencerEngine.deleteGroup(group);

    let track = sequencerEngine.addMultiFreezeTrack();
    for (let i=track.patterns.length; i < numPatterns; i++) {
        await track.newPattern(true);
    }
    
    track.freeze(bounces, true);
    track.frozenGroup = frozenGroup;
    track.frozenTracks = frozenTracks;

    for (let i=0; i < numPatterns; i++) {
        sequencerEngine.switchToPattern(i);
        track.currentPattern = i;
        track.pattern.changeLength(patternLengths[i]);
        track.frozenColumns[0].playing = i;
    }

    sequencerEngine.switchToPattern(0);
    sequencerEngine.switchToPattern(sequencerEngine.currentPattern);
    sequencerEngine.groups.groups.forEach(
        group => group.updateRedux());

    // update the pattern lengths for this new track to match
    // the max patt. length (of the tracks)
 
    sequencerEngine.store.dispatch(setLoadingText(undefined));
};

const getGroupData = (group) => {
    let frozenGroup = group.getJson();
    let frozenTracks = [];
    for (let track of group.tracks) {
        frozenTracks.push(getTrackJson(track));
    }
    // need to get the steps for each pattern
    return {frozenGroup, frozenTracks};
};
